import { render, staticRenderFns } from "./ClientMedicineInctructions.vue?vue&type=template&id=5b347ace&scoped=true"
import script from "./ClientMedicineInctructions.vue?vue&type=script&lang=js"
export * from "./ClientMedicineInctructions.vue?vue&type=script&lang=js"
import style0 from "./ClientMedicineInctructions.vue?vue&type=style&index=0&id=5b347ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b347ace",
  null
  
)

export default component.exports